/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './App.vue'

import validationMessagesEn from 'vee-validate/dist/locale/en'
import validationMessagesVi from 'vee-validate/dist/locale/vi'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)
Vue.use(VueCookies, { expires: '7d'})

// axios
// import axios from './axios.js'
// Vue.prototype.$http = axios

// Theme Configurations
// import '../themeConfig.js'

import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n/i18n'

// Vuejs - Vue wrapper for hammerjs
// import { VueHammer } from 'vue2-hammer'
// Vue.use(VueHammer)


// PrismJS
// import 'prismjs'
// import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

const dictionary = {
  nameContain: field => i18n.t('validation.nameContain', {field}),
  No_Start: field => i18n.t('validation.No_Start', {field}),
  No_End: field => i18n.t('validation.No_End', {field}),
  No__Inside: field => i18n.t('validation.No__Inside', {field}),
  glot_email: field => i18n.t('validation.glot_email', {field}),
  glot_login_acc: field => i18n.t('validation.glot_login_acc', {field})
}


// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
  i18nRootKey: 'validation',
  i18n,
  dictionary: {
    en: {...validationMessagesEn, messages: {...validationMessagesEn.messages, ...dictionary}},
    vi: {...validationMessagesVi, messages: {...validationMessagesVi.messages, ...dictionary}}
  }
})

import './validator'

Vue.config.productionTip = false

new Vue({
  data: {
    hello: 'Hello world'
  },
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')